/**
 * Draw horizontal lines in a drawing context
 * @param drawingContext {CanvasRenderingContext2D} where to draw to
 * @param color {string} CSS color for the lines
 * @param thickness {number} Thickness in pixels
 * @param width {number} Width in pixels of the drawing (integer)
 * @param height {number} Height in pixels of the drawing (integer)
 * @param lineCount {number} How many lines to draw (integer)
 */
function drawHorizontalLines(drawingContext, color, thickness, width, height, lineCount) {
    const space = height / lineCount;

    function drawHorizontalLine(iter) {
        drawingContext.beginPath();
        drawingContext.strokeStyle = color;
        drawingContext.lineWidth = thickness;
        drawingContext.lineCap = 'round';
        drawingContext.moveTo(0, (iter+thickness/2) * space);
        drawingContext.lineTo(width, (iter+thickness/2) * space);
        drawingContext.stroke();
    }

    for (let i = 0; i < lineCount; i++) {
        drawHorizontalLine(i);
    }
}

/**
 * Draw vertical lines in a drawing context
 * @param drawingContext {CanvasRenderingContext2D} where to draw to
 * @param color {string} CSS color for the lines
 * @param thickness {number} Thickness in pixels
 * @param width {number} Width in pixels of the drawing (integer)
 * @param height {number} Height in pixels of the drawing (integer)
 * @param lineCount {number} How many lines to draw (integer)
 */
function drawVerticalLines(drawingContext, color, thickness, width, height, lineCount) {
    const space = width / lineCount;

    function drawVerticalLine(iter) {
        drawingContext.beginPath();
        drawingContext.strokeStyle = color;
        drawingContext.lineWidth = thickness;
        drawingContext.lineCap = 'round';
        drawingContext.moveTo((iter+thickness/2) * space, 0);
        drawingContext.lineTo((iter+thickness/2) * space, height);
        drawingContext.stroke();
    }

    for (let i = 0; i < lineCount; i++) {
        drawVerticalLine(i);
    }
}

/**
 * Draw horizontal lines in a drawing context
 * @param drawingContext {CanvasRenderingContext2D} where to draw to
 * @param color {string} CSS color for the lines
 * @param thickness {number} Thickness in pixels
 * @param width {number} Width in pixels of the drawing (integer)
 * @param height {number} Height in pixels of the drawing (integer)
 * @param lineCount {number} How many lines to draw (integer)
 * @param anti {boolean} if true draws anti-diagonal lines
 */
function drawDiagonalLines(drawingContext, color, thickness, width, height, lineCount, anti) {
    const incX = width / (lineCount / 2 * thickness) * 2;
    const incY = height / (lineCount / 2 * thickness) * 2;

    function drawDiagonalLine(iter) {
        drawingContext.beginPath();
        drawingContext.strokeStyle = color;
        drawingContext.lineWidth = thickness;
        drawingContext.lineCap = 'round';
        drawingContext.moveTo(0, iter * incY);
        drawingContext.lineTo(width - iter * incX, height);
        drawingContext.stroke();
        if (iter > 0) {
            drawingContext.beginPath();
            drawingContext.strokeStyle = color;
            drawingContext.lineWidth = thickness;
            drawingContext.lineCap = 'round';
            drawingContext.moveTo(iter * incX, 0);
            drawingContext.lineTo(width, height - iter * incY);
            drawingContext.stroke();
        }
    }

    function drawAntiDiagonalLine(iter) {
        drawingContext.beginPath();
        drawingContext.strokeStyle = color;
        drawingContext.lineWidth = thickness;
        drawingContext.lineCap = 'round';
        drawingContext.moveTo(width, iter * incY);
        drawingContext.lineTo(iter * incX, height);
        drawingContext.stroke();
        if (iter > 0) {
            drawingContext.beginPath();
            drawingContext.strokeStyle = color;
            drawingContext.lineWidth = thickness;
            drawingContext.lineCap = 'round';
            drawingContext.moveTo(width - iter * incX, 0);
            drawingContext.lineTo(0, height - iter * incY);
            drawingContext.stroke();
        }
    }

    for (let i = 0; i < lineCount / 2; i++) {
        if (anti)
            drawAntiDiagonalLine(i);
        else drawDiagonalLine(i);
    }
}

/**
 * Draw dots in a drawing context
 * @param drawingContext {CanvasRenderingContext2D} where to draw to
 * @param color {string} CSS color for the dots
 * @param width {number} Width in pixels of the drawing (integer)
 * @param height {number} Height in pixels of the drawing (integer)
 * @param numRows {number} how many rows of dots (integer)
 * @param numCols {number} how many columns of dots (integer)
 * @param diameter {number} Dots diameter in pixels
 */
function drawDotted(drawingContext, color, width, height, numRows, numCols, diameter) {
    const marginX = width/(numCols*diameter);
    const marginY = height/(numRows*diameter);

    for(let i = 0; i < numRows; i++) { // row
        for(let j = 0; j < numCols; j++) { // column
            let x = (j * (diameter + marginX))  + (marginX / 2) + (diameter/2);
            let y = (i * (diameter + marginY))  + (marginY / 2) + (diameter/2);
            drawDot(x, y, diameter/2);
        }
    }

    function drawDot(x, y, radius) {
        drawingContext.beginPath();
        drawingContext.arc(x, y, radius, 0, 2 * Math.PI, false);
        drawingContext.fillStyle = color;
        drawingContext.fill();
    }


}

export {drawHorizontalLines, drawVerticalLines, drawDiagonalLines, drawDotted}